import HomePageContent from './HomePageContent';

export default HomePageContent;
